/*
  rein-click-ids.js — MEGA G 2026-09-28. Loaded once, globally, from layout/theme.liquid.

  1. On ANY page: if the URL carries gclid / gbraid / wbraid (Google Ads click IDs), save each
     to a first-party cookie `rein_<id>` for 90 days (path=/, SameSite=Lax, Secure).
     Skipped when Shopify's Customer Privacy API reports that marketing / sale-of-data is
     not allowed for this visitor.
  2. Fill every `input[data-rein-click-id="gclid|gbraid|wbraid"]` on the page from the URL
     (current visit wins) or the cookie, so the value rides along with a native form POST
     (e.g. contact[gclid] on /pages/get-a-free-water-analysis) and lands in the
     notification email.
  No network calls, no third-party code.
*/
(function () {
  var IDS = ['gclid', 'gbraid', 'wbraid'];
  var MAX_AGE = 90 * 24 * 60 * 60;

  function allowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return true;
      if (typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() === false) return false;
      if (typeof cp.saleOfDataAllowed === 'function' && cp.saleOfDataAllowed() === false) return false;
    } catch (e) {}
    return true;
  }

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function valid(v) { return typeof v === 'string' && /^[A-Za-z0-9_\-.]{1,512}$/.test(v); }

  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }

  var current = {};
  IDS.forEach(function (id) {
    var v = params ? params.get(id) : null;
    if (valid(v)) {
      current[id] = v;
      if (allowed()) {
        document.cookie = 'rein_' + id + '=' + encodeURIComponent(v) + '; max-age=' + MAX_AGE +
          '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
      }
    }
  });

  function fill(root) {
    (root || document).querySelectorAll('input[data-rein-click-id]').forEach(function (input) {
      var id = input.getAttribute('data-rein-click-id');
      var v = current[id] || getCookie('rein_' + id);
      if (valid(v)) input.value = v;
    });
  }

  window.ReinClickIds = { fill: fill };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fill(); });
  else fill();
})();
